import { Button, Input, InputNumber, Modal, Select, Typography, message } from "antd"
import { useContext, useEffect, useState } from "react";
import { AuthService } from "../../services/AuthService";
import { useNavigate } from "react-router-dom";
import { getUser } from "../../helpers";
import Card from "../../components/Card";
import Goback from "../../components/Goback";
import Search from "antd/es/input/Search";
import { Seperator } from "../user/new";
import { Product } from "../../models/product";
import { UserContext } from "../../context/userContext";
const { TextArea } = Input;
const { Text } = Typography;

const NewArticle = () => {
    const navigate = useNavigate();

    const { user } = useContext(UserContext)

    const [loading, setLoading] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();

    const [product, setProduct] = useState<Product>({
        name: null,
        barcode: null,
        productNo: null,
        description: null,
        categoryId: null,
        brandId: null,
        price: null,
        internalPrice: null,
        discount: 0,
        discountedPrice: null,
        storeId: null,
        quantity: null,
        storeStocks: null,
        stocks:null,
    })

    const [foundProduct, setFoundProduct] = useState<Product>({
        name: null,
        barcode: null,
        productNo: null,
        description: null,
        categoryId: null,
        brandId: null,
        price: null,
        internalPrice: null,
        discount: 0,
        discountedPrice: null,
        storeId: null,
        quantity: null,
        storeStocks: null,
        stocks: null
    })
    const [brands, setBrands] = useState<any>(null);
    const [stores, setStores] = useState<any>(null);
    const [categories, setCategories] = useState([]);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [searchLoading, setSearchLoading] = useState(false);

    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleOk = () => {
        setConfirmLoading(true);
        // setProduct({ ...foundProduct });
        setProduct(prevState => ({
            ...prevState,
            ...foundProduct,
            storeId: prevState.storeId
        }));

        setIsModalOpen(false);
        setConfirmLoading(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const getBrands = async () => {
        // setLoading(true);
        let res = await AuthService.getBrands({});
        console.log("res", res);
        if (res?.items && res?.items.length > 0) {
            setBrands(res?.items);
        }
        // setLoading(false);
    }

    const getCategories = async () => {
        // setLoading(true);
        let res = await AuthService.getCategories({});
        console.log("res", res);
        if (res?.items && res?.items.length > 0) {
            setCategories(res?.items);
        }
        // setLoading(false);
    }

    const getStores = async () => {
        // setLoading(true);
        let res = await AuthService.getStores({});
        console.log("res", res);
        if (res?.items && res?.items.length > 0) {
            setStores(res?.items);
        }
        // setLoading(false);
    }

    const discountHandler = (discount) => {
        if (discount < 0 || discount > 100) {
            setProduct({ ...product, discount: 0 })
            return;
        }
        let val = product?.price - (product?.price * discount / 100);
        setProduct({ ...product, discount: discount, discountedPrice: val })
    }

    const quantityHandler = (quantity) => {
        if (quantity < 0) {
            setProduct({ ...product, quantity: 0 })
            return;
        }
        setProduct({ ...product, quantity: quantity })
    }

    const getProductDetails = async () => {
        if(!product?.barcode){
            messageApi.open({
                type: 'error',
                content: 'Shenoni barkodin per kerkim..',
            });
            return;
        }
        setSearchLoading(true);
        let res = await AuthService.getProductDetails(product?.barcode);
        console.log("getProductDetails", res);
        if (res && res?.barcode) {
            // alert("ka nje produkt")
            setFoundProduct(res);
            showModal();
        }
        else{
            messageApi.open({
                type: 'error',
                content: 'Nuk u gjet asnje produkt me shifren qe keni shenuar',
            });
            setProduct({...product, barcode: null})
        }
        setSearchLoading(false);
    }

    const saveProduct = async () => {
        let { name, barcode, productNo, description, categoryId, brandId, price, storeId, quantity } = product;


        console.log("product payload", product);


        if (!name || !barcode || !productNo || !description || !categoryId || !brandId || !price  || !storeId || !quantity) {
            messageApi.open({
                type: 'error',
                content: 'Ploteso fushat e shenuara me *',
            });
            return;
        }

        setLoading(true);

        let res = await AuthService.createProduct(product)
        if (res) {

            messageApi.open({
                type: 'success',
                content: 'Vlera u ruajt me sukses',
            });

            setTimeout(() => {
                setLoading(false);
                navigate(`/articles`);
            }, 1000);

        }
    }

    const stockAutofillHandler = (storeId) => {
        let st = product?.stocks?.filter(el=>el.storeId == storeId);
        if(st?.length > 0){
            setProduct({...product, quantity: st[0]?.quantity, storeId: storeId});

        }
        else{
            setProduct({...product, quantity: 0,storeId: storeId});
        }
    }

    useEffect(() => {
        getBrands();
        getCategories();
        getStores();

        if (user?.details?.assignedStoreId) {
            setProduct({ ...product, storeId: user?.details?.assignedStoreId })
        }

    }, [])

    useEffect(() => {
        if (product?.price && product?.discount) {
            discountHandler(product?.discount)
        }
    }, [product?.price])

    useEffect(()=>{
        console.log("product changed:", product)
    }, [product])

    return (
        <div className="container">
            {contextHolder}
            <div className="row">
                {/* <p>{JSON.stringify(product)}</p> */}

                <div className="col-12">
                    <Goback />
                </div>
                <div className="col-lg-8">
                    <Card title="Krijo artikull te ri">
                        <form action="">
                            <div className="row">
                                {user?.details?.roleName =="Admin" && (
                                    <div className="col-12 mb-2">
                                    <Text>Pika shitese</Text>
                                    {stores && <Select
                                        labelInValue
                                        defaultValue={product?.storeId}
                                        style={{ width: "100%" }}
                                        onChange={(e: any) => {
                                            stockAutofillHandler(e?.value);
                                        }}
                                        options={stores?.map(item => ({
                                            value: item?.storeId,
                                            label: item?.storeName.toUpperCase()
                                        }))}
                                    />}
                                    <Seperator />
                                </div>
                                )}
                                <div className="col-4 mt-0">
                                    <Text>Shifra e prodhuesit *</Text>
                                    {/* <Search placeholder="input search text" onSearch={(e) => console.log(e)}  /> */}

                                    {/* <Input value={product?.barcode} onChange={(e) => setProduct({ ...product, barcode: e.target.value })} /> */}

                                    <Search value={product?.barcode} onChange={(e) => setProduct({ ...product, barcode: e.target.value })} onSearch={() => getProductDetails()} loading={searchLoading} />
                                </div>
                                <div className="col-4 mt-0">
                                    <Text>Numri i katalogut *</Text>
                                    <Input value={product?.productNo} onChange={(e) => setProduct({ ...product, productNo: e.target.value })} />
                                </div>
                                <div className="col-12 mt-3">
                                    <Text>Emri *</Text>
                                    <Input value={product?.name} onChange={(e) => setProduct({ ...product, name: e.target.value })} />
                                </div>

                                <div className="col-12">
                                    <Seperator />
                                </div>
                                <div className="col-6 mt-0">
                                    <Text>Brendi *</Text>
                                    {brands && <Select
                                        labelInValue
                                       
                                        defaultValue={product?.brandId}
                                        style={{ width: "100%" }}
                                        onChange={(e: any) => {


                                            setProduct({ ...product, brandId: e?.value })
                                        }}
                                        options={[
                                            {
                                              value: "",
                                              label: "Zgjedh brendin", 
                                              disabled: true, 
                                            },
                                            ...brands?.map(item => ({
                                              value: item?.brandId,
                                              label: item?.name.toUpperCase(),
                                            })),
                                          ]}
                                    />}
                                </div>
                                <div className="col-6 mt-0">
                                    <Text>Kategoria *</Text>
                                    {categories && <Select
                                        labelInValue
                                        value={product?.categoryId}
                                        defaultValue={product?.categoryId ? product?.categoryId : categories[0]?.categoryId}
                                        style={{ width: "100%" }}
                                        onChange={(e: any) => {


                                            setProduct({ ...product, categoryId: e?.value })
                                        }}
                                        options={[
                                            {
                                                value: "",
                                                label: "Zgjedh kategorine", 
                                                disabled: true, 
                                              },
                                            ...categories?.map(item => ({
                                                value: item?.categoryId,
                                                label: item?.categoryName.toUpperCase()
                                            }))
                                        ]}
                                    />}
                                </div>
                                <div className="col-12">
                                    <Seperator />
                                </div>
                                <div className="col-lg-3 mt-0">
                                    <Text>Cmimi Intern*</Text>

                                    <Input type="number" value={product?.internalPrice} onChange={(e) => {
                                        setProduct({ ...product, price: Number(e.target.value), internalPrice:  Number(e.target.value)})

                                    }} />
                                </div>
                                <div className="col-lg-3 mt-0">
                                    <Text>Cmimi*</Text>

                                    <Input type="number" value={product?.price} onChange={(e) => {
                                        setProduct({ ...product, price: Number(e.target.value) })

                                    }} />
                                </div>
                                <div className="col-lg-3 mt-0">
                                    <Text>Zbritje %</Text>
                                    <Input disabled={!product?.price} type="number" min={0} max={100} value={product?.discount ? product?.discount : 0} onChange={(e) => discountHandler(Number(e.target.value))} />
                                </div>
                                <div className="col-lg-3 mt-0">
                                    <Text>Cmimi i zbritjes*</Text>
                                    <Input type="number" disabled={!product?.price} value={product?.price == 0 ? 0 : product?.discountedPrice} min={0} max={product!.price} onChange={(e) => setProduct({ ...product, discountedPrice: Number(e.target.value) })} />
                                </div>
                                <div className="col-12 mt-4">
                                    <Text>Sasia*</Text>
                                    <Input type="number" value={product?.quantity} onChange={(e) => quantityHandler(e.target.value)} />
                                </div>

                                <div className="col-12 mt-3">
                                    <Text>Pershkrimi*</Text>
                                    <TextArea rows={4} value={product?.description} onChange={(e) => setProduct({ ...product, description: e.target.value })} />
                                </div>

                                <div className="col-12 mt-3">
                                    <div className="d-flex justify-content-end">
                                        <Button loading={loading} disabled={loading} type="primary" onClick={saveProduct}>Ruaj artikullin</Button>
                                    </div>
                                </div>
                            </div>

                        </form>
                    </Card>
                </div>

            </div>
            <Modal title="Produkti u gjet!"

                okText="Ploteso te dhenat automatik"
                cancelText="Anulo" open={isModalOpen} onOk={handleOk} onCancel={handleCancel} confirmLoading={confirmLoading}>
                <p>{`Produkti me shifren:${product?.barcode} u gjet ne sistem`}</p>
            </Modal>
        </div>
    )
}

export default NewArticle